import React from "react";
import { environment } from "../utils/environment";
import { GenericAnonController, GenericAnonControllerDelegate } from "./controller";
import Header from "../SharedComponents/Header/Header";
import { Box } from "@mui/material";
import styles from './styles.module.css';

interface InternalState {
  notiStr?: string | null;
}

export default class GenericAnon extends React.PureComponent<{}, InternalState> implements GenericAnonControllerDelegate {
  private controller: GenericAnonController;

  constructor(props: any) {
    super(props);
    this.controller = new GenericAnonController(this);
    this.state = {
      notiStr: null,
    };
  }

  inviteFailed() {
    this.setRedirectingText("Link inválido")
    /* window.location.href = environment.baseUrl; */
  }

  inviteSuccess(anonToken: string): void {
    this.setRedirectingText("Usuário gerado, redirecionando...");
    window.location.href = `${environment.baseUrl}/anon/?anon_token=${anonToken}`;
  }

  setRedirectingText(value: string | null) {
    this.setState({
      notiStr: value,
    });
  }

  componentDidMount(): void {
    const query = window.location.search,
          params = new URLSearchParams(query),
          token = params.get("generic_anon_token")!;

    this.controller.registerInvite(token);
  }

  redirecting() {
    if (this.state.notiStr)
      return (<div className={ styles.redir }>{ this.state.notiStr }</div>);
    else
      return (null);
  }

  render() {
    return (
      <Box
        display="flex"
        flexDirection="column"
        width="100%"
        alignItems="center"
        justifyContent="center"
        height="100vh"
      >
        <Header logoutEnabled={false}/>
        <div style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <center>
            <div className={ styles.loader } />
            { this.redirecting() }
          </center>
        </div>
      </Box>
    )
  }
}
